import { SUPPORTED_STYLES, DEFAULT_STYLE } from './platformTypes.js';

const HEX_COLOR_REGEX = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

/**
 * Validates and normalizes a hex color string.
 * Expands 3-digit hex (#abc -> #aabbcc) and returns lowercase 6-digit hex.
 * Falls back to fallbackColor if invalid.
 */
export function normalizeHexColor(color, fallbackColor) {
  if (typeof color !== 'string') return fallbackColor;
  const trimmed = color.trim();
  if (!HEX_COLOR_REGEX.test(trimmed)) return fallbackColor;

  if (trimmed.length === 4) {
    const r = trimmed[1];
    const g = trimmed[2];
    const b = trimmed[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }

  return trimmed.toLowerCase();
}

/**
 * Normalizes a raw Start.ng style payload into an immutable safe structure.
 * Guaranteed never to throw, and never mutates input.
 */
export function normalizeCharacterStyle(rawStyle = null) {
  if (!rawStyle || typeof rawStyle !== 'object') {
    return { ...DEFAULT_STYLE };
  }

  const body = SUPPORTED_STYLES.BODIES.includes(rawStyle.body)
    ? rawStyle.body
    : DEFAULT_STYLE.body;

  const hair = SUPPORTED_STYLES.HAIRSTYLES.includes(rawStyle.hair)
    ? rawStyle.hair
    : DEFAULT_STYLE.hair;

  const hat = SUPPORTED_STYLES.HATS.includes(rawStyle.hat)
    ? rawStyle.hat
    : DEFAULT_STYLE.hat;

  const accessory = SUPPORTED_STYLES.ACCESSORIES.includes(rawStyle.accessory)
    ? rawStyle.accessory
    : DEFAULT_STYLE.accessory;

  const primaryColor = normalizeHexColor(rawStyle.primaryColor, DEFAULT_STYLE.primaryColor);
  const secondaryColor = normalizeHexColor(rawStyle.secondaryColor, DEFAULT_STYLE.secondaryColor);
  const skinColor = normalizeHexColor(rawStyle.skinColor, DEFAULT_STYLE.skinColor);
  const hairColor = normalizeHexColor(rawStyle.hairColor, DEFAULT_STYLE.hairColor);

  return {
    body,
    hair,
    hat,
    accessory,
    primaryColor,
    secondaryColor,
    skinColor,
    hairColor,
  };
}
